export const platforms = Object.freeze({
  iOS: 'iOS',
  macOS: 'macOS',
});